module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "light": "",
      "dense": "",
      "flat": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "light": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_left")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v(_vm._s(_vm.getTitle) + "\r\n    ")])], 1), _vm._v(" "), _c('v-card-text', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDescription),
      expression: "showDescription"
    }]
  }, [_c('v-flex', {
    attrs: {
      "offset-xs10": ""
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.hideDescription()
      }
    }
  }, [_vm._v("\r\n      скрыть\r\n  ")])]), _vm._v(" "), _c('v-flex', [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.getDescriptionHtml)
    }
  })])], 1), _vm._v(" "), _c('v-card', {
    ref: "scroll_target",
    staticClass: "scroll-y",
    attrs: {
      "flat": "",
      "id": "scroll_target",
      "height": _vm.calcHeight()
    }
  }, [_c('v-container', {
    directives: [{
      name: "scroll",
      rawName: "v-scroll:#scroll_target",
      value: (_vm.onScroll),
      expression: "onScroll",
      arg: "#scroll_target"
    }],
    staticStyle: {
      "min-height": "0",
      "margin-top": "0"
    },
    attrs: {
      "px-2": "",
      "pt-2": "",
      "fluid": "",
      "grid-list-lg": ""
    }
  }, [_vm._l((_vm.getPosts), function(item) {
    return [_c('v-flex', {
      class: _vm.getOffsetClass(item),
      attrs: {
        "xs11": "",
        "pb-2": ""
      }
    }, [(item.typeCode === 'CHAT_INVITATION') ? _c('v-card', {
      attrs: {
        "color": _vm.getColor(item)
      }
    }, [_c('v-card-text', [_c('v-layout', {
      attrs: {
        "row": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "align-end": ""
      },
      domProps: {
        "innerHTML": _vm._s(_vm.getHTMLHeader(item))
      }
    })], 1), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.getHTMLText(item))
      }
    })], 1)], 1) : _vm._e(), _vm._v(" "), (item.typeCode === 'PLAIN') ? _c('v-card', {
      attrs: {
        "color": _vm.getColor(item)
      }
    }, [_c('v-card-text', [_c('v-layout', {
      attrs: {
        "row": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "align-end": ""
      },
      domProps: {
        "innerHTML": _vm._s(_vm.getHTMLHeader(item))
      }
    })], 1), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.getHTMLText(item))
      }
    })], 1)], 1) : _vm._e(), _vm._v(" "), (item.typeCode === 'OFFER') ? _c('v-card', {
      attrs: {
        "color": _vm.getColor(item)
      }
    }, [_c('v-card-text', [_c('v-layout', {
      attrs: {
        "row": ""
      }
    }, [_c('v-flex', [_vm._v("Оферта")]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "align-end": ""
      },
      domProps: {
        "innerHTML": _vm._s(_vm.getHTMLHeader(item))
      }
    })], 1), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.getHTMLText(item))
      }
    })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.partnerAction(item)),
        expression: "partnerAction(item)"
      }],
      attrs: {
        "disabled": !_vm.isAdmin()
      },
      on: {
        "click": function($event) {
          return _vm.changeActionState(item, 'SIGNED')
        }
      }
    }, [_vm._v("Акцепт")]), _vm._v(" "), _c('v-btn', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.partnerAction(item)),
        expression: "partnerAction(item)"
      }],
      attrs: {
        "disabled": !_vm.isAdmin()
      },
      on: {
        "click": function($event) {
          return _vm.changeActionState(item, 'REJECTED')
        }
      }
    }, [_vm._v("Отклонить")]), _vm._v(" "), _c('v-layout', {
      attrs: {
        "row": ""
      }
    }, [_c('v-flex', [_vm._v(_vm._s(_vm.resultText(item)))]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "align-end": ""
      },
      domProps: {
        "innerHTML": _vm._s(_vm.getHTMLActionSign(item))
      }
    })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.state === 'NEW' || item.state === 'UPDATED'),
        expression: "item.state === 'NEW' || item.state === 'UPDATED'"
      }],
      attrs: {
        "disabled": !_vm.isAdmin()
      },
      on: {
        "click": function($event) {
          return _vm.confirm(item)
        }
      }
    }, [_vm._v("Подтвердить")]), _vm._v(" "), _c('v-btn', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.state === 'NEW' || item.state === 'UPDATED'),
        expression: "item.state === 'NEW' || item.state === 'UPDATED'"
      }],
      attrs: {
        "disabled": !_vm.isAdmin()
      },
      on: {
        "click": function($event) {
          return _vm.rollback(item)
        }
      }
    }, [_vm._v("Отменить")])], 1)], 1) : _vm._e(), _vm._v(" "), (item.typeCode === 'OFFER_CANCEL') ? _c('v-card', {
      attrs: {
        "color": _vm.getColor(item)
      }
    }, [_c('v-card-text', [_c('v-layout', {
      attrs: {
        "row": ""
      }
    }, [_c('v-flex', [_vm._v("Отмена оферты")]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "align-end": ""
      },
      domProps: {
        "innerHTML": _vm._s(_vm.getHTMLHeader(item))
      }
    })], 1), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.getHTMLText(item))
      }
    })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-layout', {
      attrs: {
        "row": ""
      }
    }, [_c('v-flex', [_vm._v(_vm._s(_vm.resultText(item)))]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "align-end": ""
      },
      domProps: {
        "innerHTML": _vm._s(_vm.getHTMLActionSign(item))
      }
    })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.state === 'NEW' || item.state === 'UPDATED'),
        expression: "item.state === 'NEW' || item.state === 'UPDATED'"
      }],
      attrs: {
        "disabled": !_vm.isAdmin()
      },
      on: {
        "click": function($event) {
          return _vm.confirm(item)
        }
      }
    }, [_vm._v("Подтвердить")]), _vm._v(" "), _c('v-btn', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.state === 'NEW' || item.state === 'UPDATED'),
        expression: "item.state === 'NEW' || item.state === 'UPDATED'"
      }],
      attrs: {
        "disabled": !_vm.isAdmin()
      },
      on: {
        "click": function($event) {
          return _vm.rollback(item)
        }
      }
    }, [_vm._v("Отменить")])], 1)], 1) : _vm._e(), _vm._v(" "), (item.typeCode === 'ACT') ? _c('v-card', {
      attrs: {
        "color": _vm.getColor(item)
      }
    }, [_c('v-card-text', [_c('v-layout', {
      attrs: {
        "row": ""
      }
    }, [_c('v-flex', [_vm._v("Акт/Накладная")]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "align-end": ""
      },
      domProps: {
        "innerHTML": _vm._s(_vm.getHTMLHeader(item))
      }
    })], 1), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.getHTMLText(item))
      }
    })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.partnerAction(item)),
        expression: "partnerAction(item)"
      }],
      attrs: {
        "disabled": !_vm.isAdmin()
      },
      on: {
        "click": function($event) {
          return _vm.changeActionState(item, 'SIGNED')
        }
      }
    }, [_vm._v("Акцепт")]), _vm._v(" "), _c('v-btn', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.partnerAction(item)),
        expression: "partnerAction(item)"
      }],
      attrs: {
        "disabled": !_vm.isAdmin()
      },
      on: {
        "click": function($event) {
          return _vm.changeActionState(item, 'REJECTED')
        }
      }
    }, [_vm._v("Отклонить")]), _vm._v(" "), _c('v-layout', {
      attrs: {
        "row": ""
      }
    }, [_c('v-flex', [_vm._v(_vm._s(_vm.resultText(item)))]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "align-end": ""
      },
      domProps: {
        "innerHTML": _vm._s(_vm.getHTMLActionSign(item))
      }
    })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.state === 'NEW' || item.state === 'UPDATED'),
        expression: "item.state === 'NEW' || item.state === 'UPDATED'"
      }],
      attrs: {
        "disabled": !_vm.isAdmin()
      },
      on: {
        "click": function($event) {
          return _vm.confirm(item)
        }
      }
    }, [_vm._v("Подтвердить")]), _vm._v(" "), _c('v-btn', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.state === 'NEW' || item.state === 'UPDATED'),
        expression: "item.state === 'NEW' || item.state === 'UPDATED'"
      }],
      attrs: {
        "disabled": !_vm.isAdmin()
      },
      on: {
        "click": function($event) {
          return _vm.rollback(item)
        }
      }
    }, [_vm._v("Отменить")])], 1)], 1) : _vm._e(), _vm._v(" "), (item.typeCode === 'CLAIM') ? _c('v-card', {
      attrs: {
        "color": _vm.getColor(item)
      }
    }, [_c('v-card-text', [_c('v-layout', {
      attrs: {
        "row": ""
      }
    }, [_c('v-flex', [_vm._v("Претензия")]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "align-end": ""
      },
      domProps: {
        "innerHTML": _vm._s(_vm.getHTMLHeader(item))
      }
    })], 1), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.getHTMLText(item))
      }
    })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-layout', {
      attrs: {
        "row": ""
      }
    }, [_c('v-flex', [_vm._v(_vm._s(_vm.resultText(item)))]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "align-end": ""
      },
      domProps: {
        "innerHTML": _vm._s(_vm.getHTMLActionSign(item))
      }
    })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.state === 'NEW' || item.state === 'UPDATED'),
        expression: "item.state === 'NEW' || item.state === 'UPDATED'"
      }],
      attrs: {
        "disabled": !_vm.isAdmin()
      },
      on: {
        "click": function($event) {
          return _vm.confirm(item)
        }
      }
    }, [_vm._v("Подтвердить")]), _vm._v(" "), _c('v-btn', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.state === 'NEW' || item.state === 'UPDATED'),
        expression: "item.state === 'NEW' || item.state === 'UPDATED'"
      }],
      attrs: {
        "disabled": !_vm.isAdmin()
      },
      on: {
        "click": function($event) {
          return _vm.rollback(item)
        }
      }
    }, [_vm._v("Отменить")])], 1)], 1) : _vm._e(), _vm._v(" "), (item.typeCode === 'OFFER_REQUEST') ? _c('v-card', {
      attrs: {
        "color": _vm.getColor(item)
      }
    }, [_c('v-card-text', [_c('v-layout', {
      attrs: {
        "row": ""
      }
    }, [_c('v-flex', [_vm._v("Запрос оферты / коммерческого предложения")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
      attrs: {
        "align-end": ""
      },
      domProps: {
        "innerHTML": _vm._s(_vm.getHTMLHeader(item))
      }
    })], 1), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.getHTMLText(item))
      }
    })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-layout', {
      attrs: {
        "row": ""
      }
    }, [_c('v-flex', [_vm._v(_vm._s(_vm.resultText(item)))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
      attrs: {
        "align-end": ""
      },
      domProps: {
        "innerHTML": _vm._s(_vm.getHTMLActionSign(item))
      }
    })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.state === 'NEW' || item.state === 'UPDATED'),
        expression: "item.state === 'NEW' || item.state === 'UPDATED'"
      }],
      attrs: {
        "disabled": !_vm.isAdmin()
      },
      on: {
        "click": function($event) {
          return _vm.confirm(item)
        }
      }
    }, [_vm._v("Подтвердить")]), _vm._v(" "), _c('v-btn', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.state === 'NEW' || item.state === 'UPDATED'),
        expression: "item.state === 'NEW' || item.state === 'UPDATED'"
      }],
      attrs: {
        "disabled": !_vm.isAdmin()
      },
      on: {
        "click": function($event) {
          return _vm.rollback(item)
        }
      }
    }, [_vm._v("Отменить")])], 1)], 1) : _vm._e(), _vm._v(" "), (item.typeCode === 'NOTIFY') ? _c('v-card', {
      attrs: {
        "color": _vm.getColor(item)
      }
    }, [_c('v-card-text', [_c('v-layout', {
      attrs: {
        "row": ""
      }
    }, [_c('v-flex', [_vm._v("Уведомление")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
      attrs: {
        "align-end": ""
      },
      domProps: {
        "innerHTML": _vm._s(_vm.getHTMLHeader(item))
      }
    })], 1), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.getHTMLText(item))
      }
    })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-layout', {
      attrs: {
        "row": ""
      }
    }, [_c('v-flex', [_vm._v(_vm._s(_vm.resultText(item)))]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "align-end": ""
      },
      domProps: {
        "innerHTML": _vm._s(_vm.getHTMLActionSign(item))
      }
    })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.state === 'NEW' || item.state === 'UPDATED'),
        expression: "item.state === 'NEW' || item.state === 'UPDATED'"
      }],
      attrs: {
        "disabled": !_vm.isAdmin()
      },
      on: {
        "click": function($event) {
          return _vm.confirm(item)
        }
      }
    }, [_vm._v("Подтвердить")]), _vm._v(" "), _c('v-btn', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.state === 'NEW' || item.state === 'UPDATED'),
        expression: "item.state === 'NEW' || item.state === 'UPDATED'"
      }],
      attrs: {
        "disabled": !_vm.isAdmin()
      },
      on: {
        "click": function($event) {
          return _vm.rollback(item)
        }
      }
    }, [_vm._v("Отменить")])], 1)], 1) : _vm._e()], 1)]
  })], 2)], 1), _vm._v(" "), _c('v-card-actions', {
    staticStyle: {
      "align-items": "flex-end"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "light": ""
    },
    on: {
      "click": function($event) {
        return _vm.dialogOpen('DOC_SELECTOR')
      }
    }
  }, [_c('v-icon', [_vm._v("attach_file")])], 1), _vm._v(" "), _c('v-textarea', {
    ref: "focused",
    attrs: {
      "label": "Введите текст",
      "auto-grow": "",
      "rows": "1",
      "hint": "",
      "solo": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.item.text),
      callback: function($$v) {
        _vm.$set(_vm.item, "text", $$v)
      },
      expression: "item.text"
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "light": ""
    },
    on: {
      "click": _vm.addPost
    }
  }, [_c('v-icon', [_vm._v("send")])], 1), _vm._v(" "), _c('v-menu', {
    attrs: {
      "left": "",
      "min-width": "20rem"
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "icon": "",
      "light": ""
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("more_vert")])], 1), _vm._v(" "), _c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_vm._l((this.getMenus), function(item) {
    return [(item.divider) ? _c('v-divider') : _c('v-list-tile', {
      key: item.title,
      on: {
        "click": function($event) {
          return _vm.runAction(item)
        }
      }
    }, [_c('v-list-tile-title', [_vm._v(_vm._s(item.title))])], 1)]
  })], 2)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10c304f2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/Chat.vue
// module id = 1221
// module chunks = 1